// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"nu","cardInnerHeading":"nv","toggleWrapperClass":"nw","textWrapperClass":"nx","toggleTextClass":"ny"};